<section
  class="how-it-works bg-ayr-yellow-200 dark:bg-ayr-grey-1000 dark:text-ayr-white p-10"
>
  <div class="lg:max-w-960 m-auto px-8">
    <h2 class="text-37 lg:text-47 flex flex-wrap justify-center gap-2">
      <span>{{ "home.how-ayr-works.how" | translate }}</span>

      <img
        class="ayr-image inline-block"
        width="100px"
        height="40px"
        src="https://storage.googleapis.com/weayr-assets-non-prod/svg/ayr-logo.svg"
        alt="ayr_logo"
        loading="lazy"
      />

      <span
        class="ayr-underline dark:text-shadow  navigation-item-bold text-ayr-black dark:text-ayr-white "
      >
        {{ "home.how-ayr-works.works" | translate }}
      </span>
    </h2>

    <ul class="grid gap-6 lg:gap-12 mt-14 justify-center lg:grid-cols-4">
      <li
        class="flex items-center lg:items-start space-x-5 lg:space-x-0 lg:grid lg:grid-rows-[auto_1fr]"
      >
        <img
          class="m-auto w-14 lg:w-24 lg:h-24 object-contain"
          src="https://storage.googleapis.com/weayr-assets-non-prod/svg/home/icon_co2_with_search.svg"
          alt="Co2 with search icon"
          width="100px"
          height="100px"
          loading="lazy"
        />
        <p
          class="how-it-works-label navigation-item-bold flex-grow lg:mt-5 lg:text-center font-bold lg:text-21 max-w-[280px] text-left"
        >
          {{ "home.how-ayr-works.quantify.quantify" | translate }}
          {{ "home.how-ayr-works.quantify.emissions" | translate }}
          {{ "home.how-ayr-works.quantify.produce" | translate }}
        </p>
      </li>
      <li
        class="flex items-center lg:items-start space-x-5 lg:space-x-0 lg:grid lg:grid-rows-[auto_1fr]"
      >
        <img
          class="m-auto w-14 lg:w-24 lg:h-24 object-contain"
          src="https://storage.googleapis.com/weayr-assets-non-prod/svg/home/icon_co2_with_dollar.svg"
          alt="Co2 with dollar icon"
          width="100px"
          height="100px"
          loading="lazy"
        />
        <p
          class="how-it-works-label navigation-item-bold flex-grow lg:mt-5 lg:text-center font-bold lg:text-21 max-w-[280px] text-left"
        >
          {{ "home.how-ayr-works.value" | translate }}
        </p>
      </li>
      <li
        class="flex items-center lg:items-start space-x-5 lg:space-x-0 lg:grid lg:grid-rows-[auto_1fr]"
      >
        <img
          class="m-auto w-14 lg:w-24 lg:h-24 object-contain"
          src="https://storage.googleapis.com/weayr-assets-non-prod/svg/home/icon_co2_with_roller.svg"
          alt=" Co2 with roller icon"
          loading="lazy"
          width="100px"
          height="100px"
        />
        <p
          class="how-it-works-label navigation-item-bold flex-grow lg:mt-5 lg:text-center font-bold lg:text-21 max-w-[280px] text-left"
        >
          {{ "home.how-ayr-works.exchange" | translate }}
        </p>
      </li>
      <li
        class="flex items-center lg:items-start space-x-5 lg:space-x-0 lg:grid lg:grid-rows-[auto_1fr]"
      >
        <img
          class="m-auto w-14 lg:w-24 lg:h-24 object-contain"
          src="https://storage.googleapis.com/weayr-assets-non-prod/svg/home/icon_a.svg"
          alt="Ayr icon "
          width="100px"
          height="100px"
          loading="lazy"
        />
        <p
          class="how-it-works-label navigation-item-bold flex-grow lg:mt-5 lg:text-center font-bold lg:text-21 max-w-[280px] text-left"
        >
          {{ "home.how-ayr-works.offset" | translate }}
        </p>
      </li>
    </ul>

    <div
      class="duration-200 grid justify-center justify-items-center mt-9 cursor-pointer pb-2"
      (click)="playModalPlay()"
    >
      <img
        class="lg:max-w-16 max-w-12"
        width="48"
        height="48"
        src="https://storage.googleapis.com/weayr-assets-non-prod/images/home/play.png"
        alt=" Icon play"
        loading="lazy"
      />
      <p class="text-13 lg:text-18 font-bold mt-1.5">
        {{ "play-video" | translate }}
      </p>
    </div>
  </div>
</section>
